import graphQLClient from 'config/graphql-instance';
import { gql, Variables } from 'graphql-request';

const gqlRequest = async <T, V extends Variables = Variables>(queryBody: string, params?: V): Promise<T> => {
  const query = gql`${queryBody}`;

  const response = params === undefined
    ? await graphQLClient().request<T>(query)
    : await graphQLClient().request<T, Variables>(query, params);

  return response;
};

export default gqlRequest;
